import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { fr },
    current: 'fr'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#111113',
        secondary: '#111113',
        accent: '#f4f4f5',
        error: '#d93838',
        warning: '#e08600',
        info: '#2f80ed',
        success: '#2e9d5b'
      }
    }
  }
})
